/**
 * 观看限制 - 密码
 * Create by liaokai on 2020-06-11 16:48:54
 */
import * as React from 'react';
import {Component} from "react";
import {Input, InputNumber} from "antd";
import {TitleContentTable} from "../../../../../meeting-list/meeting/menu/lecturer/preview/title-content-table/title-content-table";

const {Password} = Input

interface IProps {
    data? : IState
    onChange? : (data : IState) => void
}

interface IState{
    type : number,  //1免费 2 收费 3 邀请码 4 密码 5 白名单
    password : string
}

export class LiveLimitPwd extends Component<IProps,IState>{
    readonly state : IState = this.props?.data ?? {
        type : 4,
        password : ""
    };

    componentDidMount() {
        this.props.onChange?.(this.state)
    }

    render() {
        let {onChange} = this.props;
        let {password} = this.state;
        return (
            <div>
                <TitleContentTable rowGap={10} colGap={10}>
                    <div>观看密码</div>
                    <div style={{width: "50%"}}>
                        <Password value={password} onChange={value => {
                            this.setState({password : value.target.value},()=>{
                                onChange?.(this.state)
                            })
                        }}/>
                    </div>
                </TitleContentTable>
            </div>
        );
    }
}
